import axiosConfig from "../../config/axios";
export const login = payload => {
  return axiosConfig({
    url: `/rest-auth/login/`,
    method: "POST",
    data: payload
  });
};

export const logout = payload => {
  return axiosConfig({
    url: `/rest-auth/logout/`,
    method: "POST",
    data: payload
  });
};

export const resetPassword = payload => {
  return axiosConfig({
    url: `/rest-auth/password/reset/confirm/`,
    method: "POST",
    data: payload
  });
};

export const changePassword = payload => {
  return axiosConfig({
    url: `/rest-auth/password/change/`,
    method: "POST",
    data: payload
  });
};

export const sendResetLink = payload => {
  return axiosConfig({
    url: `/rest-auth/password/reset/`,
    method: "POST",
    data: payload
  });
};

export const sendInviteLink = payload => {
  return axiosConfig({
    url: `/assistants/`,
    method: "POST",
    data: payload
  });
};

export const signInWithGoogle = payload => {
  return axiosConfig({
    url: `/rest-auth/google/`,
    method: "post",
    data: payload
  });
};

export const getProfile = () => {
  return axiosConfig({
    url: `/me/`,
    method: "get"
  });
};

export const getCommunications = (profileId, role) => {
  if (role === "admin") {
    return axiosConfig({
      url: `/admins/${profileId}/communications/`,
      method: "get"
    });
  } else {
    return axiosConfig({
      url: `/assistants/${profileId}/communications/`,
      method: "get"
    });
  }
};

export const getCommunicationIDs = role => {
  return axiosConfig({
    url: `/communications/?label=${role}`,
    method: "get"
  });
};

export const postCommunications = (profileId, payload, role) => {
  if (role === "admin") {
    return axiosConfig({
      url: `/admins/${profileId}/communications/`,
      method: "post",
      data: payload
    });
  } else {
    return axiosConfig({
      url: `/assistants/${profileId}/communications/`,
      method: "post",
      data: payload
    });
  }
};

export const patchCommunications = (profileId, payload, role) => {
  if (role === "admin") {
    return axiosConfig({
      url: `/admins/${profileId}/communications/`,
      method: "patch",
      data: payload
    });
  } else {
    return axiosConfig({
      url: `/assistants/${profileId}/communications/`,
      method: "patch",
      data: payload
    });
  }
};

export const getLoggedInUserDetails = () => {
  return axiosConfig({
    url: "/me/",
    method: "GET"
  });
};

export const postEmploymentSettings = (profileId, assistantID, payload) => {
  return axiosConfig({
    url: `/assistants/${profileId}/assistant/${assistantID}/`,
    method: "patch",
    data: payload
  });
};
export const saveSpecialities = (profileId, assistantID, payload) => {
  return axiosConfig({
    url: `/assistants/${profileId}/profile/${assistantID}/`,
    method: "patch",
    data: payload
  });
};

export const getEmploymentSettings = profileId => {
  return axiosConfig({
    url: `/assistants/${profileId}/assistant/`,
    method: "get"
  });
};

export const patchAddress = (profileId, payload, id, role) => {
  if (role === "admin") {
    return axiosConfig({
      url: `/admins/${profileId}/address/${id}/`,
      data: payload,
      method: "patch"
    });
  } else {
    return axiosConfig({
      url: `/assistants/${profileId}/address/${id}/`,
      data: payload,
      method: "patch"
    });
  }
};

export const postAddress = (profileId, payload, role) => {
  if (role === "admin") {
    return axiosConfig({
      url: `/admins/${profileId}/address/`,
      data: payload,
      method: "post"
    });
  } else {
    return axiosConfig({
      url: `/assistants/${profileId}/address/`,
      data: payload,
      method: "post"
    });
  }
};
export const getAddress = (profileId, role) => {
  if (role === "admin") {
    return axiosConfig({
      url: `/admins/${profileId}/address/`,
      method: "get"
    });
  } else {
    return axiosConfig({
      url: `/assistants/${profileId}/address/`,
      method: "get"
    });
  }
};

export const postName = (profileId, userId, payload, role) => {
  if (role === "admin") {
    return axiosConfig({
      url: `/admins/${profileId}/user/${userId}/`,
      method: "patch",
      data: payload
    });
  } else {
    return axiosConfig({
      url: `/assistants/${profileId}/user/${userId}/`,
      method: "patch",
      data: payload
    });
  }
};

export const patchAvatar = (profileID, payload, role) => {
  if (role === "assistant" || role === "owner") {
    return axiosConfig({
      url: `/assistants/${profileID}/avatar/`,
      method: "patch",
      data: payload
    });
  } else if (role === "admin") {
    return axiosConfig({
      url: `/admins/${profileID}/avatar/`,
      method: "patch",
      data: payload
    });
  } else if (role === "customer") {
    return axiosConfig({
      url: `/customers/${profileID}/avatar/`,
      method: "patch",
      data: payload
    });
  }
};

export const getNotificationIDs = role => {
  return axiosConfig({
    url: `/notifications?notification_for=${role}`,
    method: "get"
  });
};

export const getNotifications = profileID => {
  return axiosConfig({
    url: `/assistants/${profileID}/notifications/`,
    method: "get"
  });
};

export const postNotifications = (profileID, payload) => {
  return axiosConfig({
    url: `/assistants/${profileID}/notifications/`,
    method: "post",
    data: payload
  });
};

export const patchNotifications = (profileID, payload) => {
  return axiosConfig({
    url: `/assistants/${profileID}/notifications/`,
    method: "patch",
    data: payload
  });
};

export const createCustomer = payload => {
  return axiosConfig({
    url: `/customers/`,
    data: payload,
    method: "post"
  });
};
